/**
 * CORE-1457 — короткое сообщение, которое переживает переход на другой экран.
 *
 * Экран, решивший что-то сказать, часто тут же уходит сам: исключённого из
 * Live-сессии уводит в Ленту, и тост, нарисованный комнатой, пропал бы вместе
 * с ней. Поэтому сообщение отдаётся наверх, а показывает его один хост в корне
 * приложения (`FlashNoticeHost`) — поверх того экрана, куда человек пришёл.
 *
 * Обычный модуль без провайдера, как `cookieBannerInset`: писателей мало,
 * читатель один.
 */
type FlashNoticeListener = (message: string) => void;

const listeners = new Set<FlashNoticeListener>();

export function showFlashNotice(message: string): void {
  if (!message) return;
  listeners.forEach((listener) => listener(message));
}

export function subscribeFlashNotice(listener: FlashNoticeListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Что сейчас показывает хост: текст и номер показа. */
export interface FlashNotice {
  message: string;
  seq: number;
}

/**
 * CORE-1479 (возврат QA 23.10) — каждый `showFlashNotice` — новый показ, даже с
 * тем же текстом. Раньше хост держал одну строку: тот же текст — то же
 * состояние, React не перерисовывал, отсчёт не начинался заново, и повторное
 * нажатие по закрытой реакции под конец тоста не показывало ничего — тост
 * гас через мгновение после нажатия.
 */
export function nextFlashNotice(prev: FlashNotice | null, message: string): FlashNotice {
  return { message, seq: (prev?.seq ?? 0) + 1 };
}

/** Скрыть только закончившийся показ, а не тот, что пришёл ему на смену. */
export function hideFlashNotice(prev: FlashNotice | null, seq: number): FlashNotice | null {
  return prev && prev.seq === seq ? null : prev;
}
